<template>
  <div class="button-group">
    <o-button
      :disabled="removeDisabled"
      class="button"
      @click="remove"
    >
      -
    </o-button>
    <div class="amount">
      {{ value }}
    </div>
    <o-button
      :disabled="addDisabled"
      class="button"
      @click="add"
    >
      +
    </o-button>
  </div>
</template>

<script>
import OButton from "@/components/OButton";
export default {
  name: 'OIncrement',
  components: {OButton},
  props: {
    addDisabled: {
      type: Boolean,
      default: false,
    },

    removeDisabled: {
      type: Boolean,
      default: false,
    },

    value: {
      type: Number,
      default: 0,
    },
  },

  methods: {
    add() {
      this.$emit('add');
    },

    remove() {
      this.$emit('remove');
    }
  }
}
</script>

<style scoped>
.button-group {
  display: flex;
  align-items: center;
}

.amount {
  font-weight: 600;
  font-size: 18px;
  padding: 6px 20px 0 23px;
}

.button {
  font-size: 17px;
  font-weight: 900;
  width: 35px;
  padding: 0;
  height: 35px;
}
</style>
